import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";
import {IVanillaReaderTimelineProgressData} from "../VanillaReader/VanillaReaderModel";
import {IVanillaReaderAppEvent_NAVIGATION_INTENT} from '../VanillaReaderEventBus/IVanillaReaderAppEventTypeMap';

export interface VanillaReaderUiSliderProgressionController extends IVanillaReaderUiComponentController, IVanillaReaderUI {}

/**
 * # VanillaReaderUiMenuController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiMenu` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiMenu
 *
 */
export class VanillaReaderUiSliderProgressionController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.menuProgressionSlider.onNavigateToTimelinePosition(vanillaReaderUiContext._onProgressionSliderNavigateToTimelinePosition.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuProgressionSlider.onProgressionSliderUpdated(vanillaReaderUiContext._onProgressionSliderPositionUpdated.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuProgressionSlider.onNavigateNext(vanillaReaderUiContext._onProgressionSliderNavigateNext.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuProgressionSlider.onNavigatePrevious(vanillaReaderUiContext._onProgressionSliderNavigatePrevious.bind(vanillaReaderUiContext));
    }

    _onProgressionSliderNavigateNext(): void {
        this.navigateNext();
    };

    _onProgressionSliderNavigatePrevious(): void {
        this.navigatePrevious();
    };

    _onProgressionSliderNavigateToTimelinePosition(navigationData: IVanillaReaderAppEvent_NAVIGATION_INTENT): void {
        if (navigationData.position !== undefined) {
            this.navigateToTimelinePosition(navigationData.position);
        }
    };

    _onProgressionSliderPositionUpdated(_sliderValue: number, progressData: IVanillaReaderTimelineProgressData): void {
        if(progressData.pageData && progressData.pageProgress !== undefined) {
            this.labelPageNumber.value = progressData.pageData?.label;
            this.labelPageNumber.progress = progressData.pageProgress;
        }
    }
}
